export enum MatchInterviewType {
  Interview = 'interview',
  PostponedInterview = 'rescheduled_interview',
  TrialDay = 'trial_day',
  PostponedTrialDay = 'rescheduled_trial_day',
  Avu = 'avu',
  PostponedAvu = 'rescheduled_avu',
  Telephonic = 'phone',
  PostponedTelephonic = 'rescheduled_phone',
  Digital = 'digital',
  PostponedDigital = 'rescheduled_digital',
  Fictional = 'fictional',
  SecondInterview = 'second_interview',
  SecondTrialDay = 'second_trial_day',
  PostponedSecondInterview = 'rescheduled_second_interview',
  PostponedSecondTrialDay = 'rescheduled_second_trial_day',
}

export const SHORT_INTERVIEW_TYPES = [
  MatchInterviewType.Avu,
  MatchInterviewType.Digital,
  MatchInterviewType.Fictional,
  MatchInterviewType.Interview,
  MatchInterviewType.PostponedAvu,
  MatchInterviewType.PostponedDigital,
  MatchInterviewType.PostponedInterview,
  MatchInterviewType.PostponedTelephonic,
  MatchInterviewType.Telephonic,
  MatchInterviewType.SecondInterview,
  MatchInterviewType.PostponedSecondInterview,
];

export const NO_ICS_ATTACHMENT_INTERVIEW_TYPES = [
  MatchInterviewType.Telephonic,
  MatchInterviewType.PostponedTelephonic,
  MatchInterviewType.Digital,
  MatchInterviewType.PostponedDigital,
];

export const LONG_INTERVIEW_TYPES = [
  MatchInterviewType.PostponedTrialDay,
  MatchInterviewType.TrialDay,
  MatchInterviewType.SecondTrialDay,
  MatchInterviewType.PostponedSecondTrialDay,
];

export const MATCH_INTERVIEW_TYPES_I18N: Record<MatchInterviewType, string> = {
  [MatchInterviewType.Avu]: 'AVU',
  [MatchInterviewType.Digital]: 'Digital',
  [MatchInterviewType.Fictional]: 'Fictiv',
  [MatchInterviewType.Interview]: 'VT',
  [MatchInterviewType.PostponedAvu]: 'Verschobene AVU',
  [MatchInterviewType.PostponedDigital]: 'Verschobene Digital',
  [MatchInterviewType.PostponedInterview]: 'Verschobene VT',
  [MatchInterviewType.PostponedTelephonic]: 'Verschobene Telefon',
  [MatchInterviewType.PostponedTrialDay]: 'Verschobene HT',
  [MatchInterviewType.Telephonic]: 'Telefon',
  [MatchInterviewType.TrialDay]: 'HT',
  [MatchInterviewType.SecondInterview]: 'Zweiter VT',
  [MatchInterviewType.PostponedSecondInterview]: 'Verschobene Zweiter VT',
  [MatchInterviewType.SecondTrialDay]: 'Zweiter HT',
  [MatchInterviewType.PostponedSecondTrialDay]: 'Verschobene Zweiter HT',
};
